// Website-specific version: uses the real browser Notification API instead
// of @tauri-apps/plugin-notification (not installed here, and a static
// top-level import of it would fail to resolve at build time regardless).
// Same function signature as the desktop app's version, so callers
// (Monitor.jsx's cutoff alert) don't need to change at all.
export async function notify(title, body) {
  try {
    if (!("Notification" in window)) return;
    let permission = Notification.permission;
    if (permission === "default") {
      permission = await Notification.requestPermission();
    }
    if (permission === "granted") {
      new Notification(title, { body });
    }
  } catch (e) {
    console.warn("Notification failed:", e);
  }
}
